import { render, staticRenderFns } from "./TruckTop.vue?vue&type=template&id=04a9542b&scoped=true&"
import script from "./TruckTop.vue?vue&type=script&lang=js&"
export * from "./TruckTop.vue?vue&type=script&lang=js&"
import style0 from "./TruckTop.vue?vue&type=style&index=0&id=04a9542b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a9542b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VList,VListTile,VListTileTitle,VMenu})
